import React from 'react';
import TabbedPage from '../../../Elements/TabbedPage';
import ClientPrePaymentDetailsInfoTab from './ClientPrePaymentDetailsInfoTab';
import ClientPrePaymentDetailsPaymentsTab from './ClientPrePaymentDetailsPaymentsTab';

export default class ClientPrePaymentDetails extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);

    this.state = {};
  }

  urlParams = new URLSearchParams(window.location.search);
  PrepaymentId = this.urlParams.get('id');

  static getMenuText() {
    const id = new URLSearchParams(window.location.search).get('id');
    return `Prepayment ${id ? '- ' + id : 'Details'}`;
  }

  tabs = [
    {
      label: 'Information',
      id: 'info',
      icon: 'fa-solid fa-info',
      component: <ClientPrePaymentDetailsInfoTab prepaymentId={this.PrepaymentId} />
    },
    {
      label: 'Client Payments',
      id: 'comments',
      icon: 'fa-solid fa-money-check',
      component: <ClientPrePaymentDetailsPaymentsTab prepaymentId={this.PrepaymentId} />
    }
  ];

  render() {
    return (
      <div className='contentwrapper'>
        <TabbedPage tabs={this.tabs} />
      </div>
    );
  }
}
